import { DefaultApi } from '../autogenerated/spdApiClient/apis/DefaultApi';

export interface SzafirContextInterface {
  getTaskListForJudgment: (
    documentId: string,
    english: boolean,
  ) => Promise<string>;
  getTaskListForSupportingExamination: (documentId: string) => Promise<string>;
  getTaskListForCard: (documentId: string) => Promise<string>;
  getTaskListForJudgmentP1: (documentId: string) => Promise<string>;
}

export const SzafirContext = (api: DefaultApi) => {
  return {
    getTaskListForJudgment: (documentId: string, english: boolean) =>
      api.szafirControllerGetTaskListForJudgment(documentId, english),
    getTaskListForSupportingExamination: (documentId: string) =>
      api.szafirControllerGetTaskListForSupportingExamination(documentId),
    getTaskListForCard: (documentId: string) =>
      api.szafirControllerGetTaskListForCard(documentId),
    getTaskListForJudgmentP1: (documentId: string) =>
      api.szafirControllerGetTaskListForJudgmentP1(documentId),
  };
};
